import { startLoader } from "@Core/loader";
export class Kernel {
    boot(){
        console.log('debug')
        startLoader();
    }
}